export const apiUrl = 'https://narodnaya.tdme.ru:5001/'

